document.addEventListener("DOMContentLoaded", function() {
  Shopify.Products.recordRecentlyViewed();

  setTimeout(function() {
    const data = JSON.parse(localStorage.getItem('shopify_recently_viewed'));
    if (data && data.length > 0 && !data[0].featured_image) {
      const image = document.querySelector('.product__media img');
      if (image) {
        data[0].featured_image = image.getAttribute('src');
        localStorage.setItem('shopify_recently_viewed', JSON.stringify(data));
      }
    }
  }, 1000);
});